import { postMessageToRN } from './RNCommunicator/postMessageToRN.util';

/**
 * 기본 진동 (400ms)
 */
export const vibrateDefault = () => {
  // React Native WebView 환경
  if (typeof window.ReactNativeWebView !== 'undefined') {
    postMessageToRN({
      messageKey: 'vibrate',
      messageData: {},
    });
    return;
  }

  // 브라우저 환경
  if ('vibrate' in navigator) {
    navigator.vibrate(400);
  }
};

/**
 * 특정 시간만큼 진동
 * @param duration 진동 시간 (밀리초)
 */
export const vibrateWithDuration = (duration: number) => {
  // React Native WebView 환경
  if (typeof window.ReactNativeWebView !== 'undefined') {
    postMessageToRN({
      messageKey: 'vibrate',
      messageData: { duration },
    });
    return;
  }

  // 브라우저 환경
  if ('vibrate' in navigator) {
    navigator.vibrate(duration);
  }
};

/**
 * 패턴 진동
 * @param pattern [대기, 진동, 대기, 진동, ...] 형태의 배열 (밀리초 단위)
 * @example vibrateWithPattern([0, 1000, 500, 2000]) // 1초 진동, 0.5초 대기, 2초 진동
 */
export const vibrateWithPattern = (pattern: number[]) => {
  // React Native WebView 환경
  if (typeof window.ReactNativeWebView !== 'undefined') {
    postMessageToRN({
      messageKey: 'vibrate',
      messageData: { pattern },
    });
    return;
  }

  // 브라우저 환경에서는 기본 진동으로 대체
  if ('vibrate' in navigator) {
    navigator.vibrate(400);
  }
};

/**
 * 사용자의 주의를 집중시키기 위한 진동 (200ms)
 * 전화 모달 등 사용자의 이목을 끌어야 할 때 사용
 */
export const vibrateForAttention = () => {
  // React Native WebView 환경
  if (typeof window.ReactNativeWebView !== 'undefined') {
    postMessageToRN({
      messageKey: 'vibrate',
      messageData: { duration: 200 },
    });
    return;
  }

  // 브라우저 환경
  if ('vibrate' in navigator) {
    navigator.vibrate(200);
  }
};
